export enum StakingAction {
  DELEGATE,
  UNDELEGATE,
  REDELEGATE
}
